module.exports = __webpack_public_path__ + "img/rejected.bf6f6502.svg";